export default __webpack_public_path__ + "static/media/1.ca4b2aec.svg";